<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For all the women who showed me trails</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?eeb8a6b4